import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from '../../lib/utils'

const inputVariants = cva(
  "flex w-full border border-input bg-transparent text-body shadow-sm transition-colors file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      inputSize: {
        sm: "h-8 px-2.5 py-1 text-body-sm file:text-body-sm",
        default: "h-9 px-3 py-1 file:text-body-sm",
        lg: "h-10 px-3.5 py-2 file:text-body-sm",
      },
      variant: {
        default: "rounded-lg",
        /** Command palette / search dialog — borderless inline field */
        ghostInline:
          "h-auto min-h-0 rounded-none border-0 bg-transparent p-0 shadow-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
      },
    },
    defaultVariants: {
      inputSize: "default",
      variant: "default",
    },
  }
)

export type InputProps = React.ComponentProps<"input"> &
  VariantProps<typeof inputVariants>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ inputSize, variant, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input, inputVariants }
